var exports = {
  "K": "xaf9ae18d--b4b618--icon",
};

module.exports = exports;
